import PropTypes from 'prop-types';

// material-ui
import { useColorScheme } from '@mui/material/styles';

// PrivacyPal wordmark (icon + "PrivacyPal"). AirOps brand kit #30260.
// Black wordmark on light surfaces; light/white wordmark on dark surfaces
// (reverse), and always the light wordmark in dark mode.
import logoBlack from 'assets/images/logo/privacypal-logo-black.png';
import logoLight from 'assets/images/logo/privacypal-logo-light.png';

// ==============================|| MAIN LOGO — PRIVACYPAL WORDMARK ||============================== //

export default function LogoMain({ reverse }) {
  const { mode } = useColorScheme();
  const useLight = reverse || mode === 'dark';
  return (
    <img
      src={useLight ? logoLight : logoBlack}
      alt="PrivacyPal"
      height={34}
      style={{ height: 34, width: 'auto', display: 'block' }}
    />
  );
}

LogoMain.propTypes = { reverse: PropTypes.bool };
